;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	function windowPopup(url, width, height) {
	  // Calculate the position of the popup so
	  // it’s centered on the screen.
	  var left = (screen.width / 2) - (width / 2),
		  top = (screen.height / 2) - (height / 2);

	  window.open(
		url,
		"",
		"menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
	  );
	}

	function dotdotdot() {
		var truncate = $(".posts-section").find( '.post-type1, .post-type2, .post-type3' ).find('.post-content');
		if( ! $('body').hasClass('mobile') ) {
			truncate.not('.is-truncated').dotdotdot({
				watch: true,
				tolerance:-30,
				ellipsis: ''
			});
		}else{
			truncate.has('.is-truncated').each(function() {
				$(this).trigger('destroy');
			});

		}
	}

	function fitTextHeight() {
		if( ! $('body').hasClass('breakpoint-palm') ) {

			var container = $(".posts-section").find( '.post-type4' ).find('.post-content');

			container.fitTextCheck();
		}
	}



	$win.on('load', function() {

		dotdotdot();
		fitTextHeight();


		// Init Slider
		$('.slider .owl-carousel').owlCarousel({
			'items': 1,
			loop: true,
			autoplay: false,
			autoplayHoverPause: true,
			autoplaySpeed: 400
		});

		if( window.location.hash == "#comments" ) {
			$('.add-comment').find('i').toggleClass('fa-plus').toggleClass('fa-minus');
			$('.comments-area').show(0);
		}

		$('.add-comment').on( 'click', function(event) {
			event.preventDefault();
			$(this).find('i').toggleClass('fa-plus').toggleClass('fa-minus');
			$('.comments-area').slideToggle();
		});

		$('.search-drawer').on( 'click', function(event) {
			event.preventDefault();
			$(this).parent().toggleClass('active');
			$('.section-search').slideToggle();
		});



	});

	$doc.on( 'post-load', function () {
		dotdotdot();
		fitTextHeight();

	});

	$doc.ready(function() {

		$("body").breakpoints({
			"palm": 480,
			"mobile": 768,
			"lap": 1044,
			'desk':99999,
			"portable": { min: 0, max: 680 },
			"lap-and-up": { min: 481, max: 99999 }
		});

		// Set Side Navigation Width
		if($win.width() > 1500) {
			$('.nav-offset').css({
				'width': function() {
					return $win.width() - $('.nav-btn').offset().left - $('.nav-btn').outerWidth();
				}
			});
		} else {
			$('.nav-offset').css({'width': 'auto' });
		}

		// Open Side Navigation
		$('.nav-btn').on('click', function(event) {
			event.preventDefault();
			event.stopPropagation();
			$('.nav-offset').toggleClass('nav-show');
		});

		$('.main, #masthead, .footer').on( 'click', function( event ) {
			if( $('.nav-offset').hasClass('nav-show') )
			$('.nav-offset').removeClass('nav-show');
		});

		// Close Side Navigation
		$('.nav-close').on('click', function(event) {
			event.preventDefault();

			$('.nav-offset').removeClass('nav-show');
		});

		// Start Video
		$('.btn-play').on('click', function(event) {
			event.preventDefault();

			$(this).addClass('hidden');
			$(this).next().attr('src', $(this).next().attr('src') + '?rel=0&autoplay=1');
		});

		// Accordion
		(function(){
			// This class will be added to the expanded item
			var activeItemClass = 'accordion-expanded';
			var accordionItemSelector = '.accordion-section';
			var toggleSelector = '.accordion-head';

			$(toggleSelector).on('click', function() {

				$(this)
					.closest(accordionItemSelector) // go up to the accordion item element
					.toggleClass(activeItemClass)
						.siblings()
						.removeClass(activeItemClass);
			});

		})();

		$.fn.doPlaceholders = function() {
			if ($.support.placeholder) {
				return this;
			}

			var $fields = this.filter(function () {
				// Don't re-initialize
				return !$(this).data('didPlaceholders');
			});

			$fields.on('focus blur', function(event) {
				var placeholder = this.getAttribute('placeholder');

				if (event.type === 'focus' && placeholder === this.value) {
					this.value = '';
				} else if (event.type === 'blur' && this.value === '') {
					this.value = placeholder;
				}
			});

			// Set the initial value to the title
			$fields.each(function() {
				if (this.value === '') {
					this.value = this.getAttribute('placeholder');
				}
			});

			// Mark the fields as initialized
			$fields.data('didPlaceholders', true);

			// Alllow
			return $fields;
		};

		$.support.placeholder = (function() {
			return 'placeholder' in document.createElement('input');
		})();

		/* Don't select elements if placeholder is natively supported*/
		if (!$.support.placeholder) {
			$('input[placeholder], textarea[placeholder]').doPlaceholders();
		}

		$(".js-social-share").on("click", function(e) {
		  e.preventDefault();

		  windowPopup($(this).attr("href"), 500, 300);
		});

		// Vanilla JavaScript
		var jsSocialShares = document.querySelectorAll(".js-social-share");
		if (jsSocialShares) {
		  [].forEach.call(jsSocialShares, function(anchor) {
			anchor.addEventListener("click", function(e) {
			  e.preventDefault();

			  windowPopup(this.href, 500, 300);
			});
		  });
		}
	});

	$win.on('resize', function() {
		dotdotdot();
		fitTextHeight();


		// Set Side Navigation Width
		if($win.width() > 1500) {
			$('.nav-offset').css({
				'width': function() {
					return $win.width() - $('.nav-btn').offset().left - $('.nav-btn').outerWidth();
				}
			});
		} else {
			$('.nav-offset').css({'width': 'auto' });
		}
	});

	$(document.body).on("added_to_cart", function( a, b ) {
		var nav = $('.nav-utilities .cart-link');
		var count_container = nav.find('.fa-shopping-cart sup');
		var count = count_container.text();

		count++;

		count_container.text(count++);

		if( nav.hasClass('visuallyhidden') )
			nav.removeClass('visuallyhidden');
	});
})(jQuery, window, document);
